<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#6783B2">
        <path
          d="M4.5 0c.276 0 .5.224.5.5v15c0 .276-.224.5-.5.5h-4c-.276 0-.5-.224-.5-.5V.5C0 .224.224 0 .5 0zm9 0c.276 0 .5.224.5.5v15c0 .276-.224.5-.5.5h-4c-.276 0-.5-.224-.5-.5V.5c0-.276.224-.5.5-.5zM4 1H1v14h3V1zm9 0h-3v14h3V1z"
          transform="translate(1)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'PauseIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
